import React, { createContext, useContext, useState } from "react";
import { resetChatSession } from "../utils/chatSession";

const AuthContext = createContext(null);

// 👇 this lets non-React code trigger logout
let externalLogout = null;

// Plain fetch, not the api client: a 401 here must not re-trigger forceLogout.
export function notifyLogout() {
  const token = localStorage.getItem("adm_panel_token");
  if (!token) return;
  fetch("https://youtubereader.api.adsctv.net/logout", {
    method: "POST",
    headers: { Token: token },
    keepalive: true,
  }).catch(() => {});
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("adm_panel_user")) || null;
      if (stored && stored.role !== "SUPERADMIN") {
        localStorage.removeItem("adm_panel_user");
        localStorage.removeItem("adm_panel_token");
        return null;
      }
      return stored;
    } catch {
      return null;
    }
  });

  function login(userData) {
    // A fresh sign-in gets the assistant's greeting again, even in a tab that
    // has already had one.
    resetChatSession();
    setUser(userData);
    localStorage.setItem("adm_panel_user", JSON.stringify(userData));
  }

  function logout() {
    notifyLogout();
    setUser(null);
    localStorage.removeItem("adm_panel_user");
    localStorage.removeItem("adm_panel_token");
  }

  // expose logout globally
  externalLogout = logout;

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

// 👇 this will be used by fetch wrapper
export function forceLogout() {
  if (externalLogout) {
    externalLogout();
  }
  window.location.href = "/login";
}
